import { singleton, inject } from "tsyringe";

// interface
import type { NavigationService } from "@/shared/libs/navigation/interface";
import type { AuthenticationStore } from "@/entities/user/infrastructure/userStore";

// usecase
import { PersistStorageDeleter } from "@/features/authentication/services/usecase/_workers/PersistStorageDeleter";

@singleton()
export class EnforceLogoutUsecase {
    constructor(
        @inject("NavigationService") private navigationService: NavigationService,
        @inject(PersistStorageDeleter) private persistStorageDeleter: PersistStorageDeleter,
    ) {}

    public execute = async (authStore: AuthenticationStore) => {
        authStore.resetState();
        this.persistStorageDeleter.delete();
        await new Promise((resolve) => setTimeout(resolve, 200));

        this.navigationService.navigateTo("/auth");
    };
}
